


















import Vue from "vue";
import { AuthExpirationToken } from "@/types";
import { api } from "@/helpers/ApiClient";

const AUTH_TOKEN_EXPIRATION = "X-Auth-Token-Expiration";

interface State {
  token: AuthExpirationToken | null;
  time: number | null;
  isTimerActive: boolean;
}
export default Vue.extend({
  name: "AutoLogout",
  data(): State {
    return {
      token: null,
      time: null,
      isTimerActive: false
    };
  },
  mounted() {
    this.tokenLoop();
  },
  methods: {
    tokenLoop() {
      this.fetchNewToken();
      // proactively lookup expiration token every minute
      setTimeout(this.tokenLoop, 1000 * 60);
    },
    fetchNewToken() {
      api
        .get("/rest-api/users/expiration-token")
        .then(resp => {
          this.token = this.parseExpirationToken(resp.data.data);
          this.isTimerActive = false;
          this.time = null;
          this.checkExpiration();
        })
        .catch(err => {
          if (err.response.status === 403) {
            window.location.href = "/login";
          }
          console.error(err.response.status);
        });
    },
    logout() {
      window.location.href = "/logout";
    },
    parseExpirationToken(token: string): AuthExpirationToken | null {
      if (token) {
        const base64 = token.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function(c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );

        return JSON.parse(jsonPayload);
      }
      return null;
    },
    timer() {
      if (this.token && this.isTimerActive) {
        this.time = Math.floor(
          (this.token.refreshTokenExpiration - Date.now()) / 1000
        );
        if (this.time > 0) {
          setTimeout(() => {
            this.timer();
          }, 1000);
        } else {
          window.location.href = "/logout";
        }
      }
    },
    checkExpiration() {
      if (this.token) {
        const now = new Date();
        const authExpiring =
          this.token.authTokenExpiration - now.getTime() - 60000 < 0;
        const refreshExpiring =
          this.token.refreshTokenExpiration - now.getTime() - 60000 < 0;

        if (authExpiring && refreshExpiring) {
          this.isTimerActive = true;
          this.timer();
        } else {
          this.isTimerActive = false;
          setTimeout(() => this.checkExpiration(), 5000);
        }
      }
    }
  }
});
